import { RELAY_API_CONTENTFUL } from "@/utils/constant";

import { init as initRelay } from "../../../../init-relay-streaming";
import { ConfluenceTemplateCollectionDetailsRelayPage } from "../../../../pages/software/confluence/templates/collections/confluence-template-collection-details-contentful-relay-page";
import {
    ConfluenceTemplateCollectionDetailsRelayPageQuery,
    getConfluenceTemplateCollectionDetailsRelayPageQueryVars
} from "../../../../templates/software/confluence/templates/confluence-templates-page/src/relay/contentful-relay/confluence-template-collection-details-contentful-relay-page.template";

initRelay(
    ConfluenceTemplateCollectionDetailsRelayPage,
    ConfluenceTemplateCollectionDetailsRelayPageQuery,
    getConfluenceTemplateCollectionDetailsRelayPageQueryVars(window.location),
    RELAY_API_CONTENTFUL
);
